import Vue from "vue";
import Router from "vue-router";
import FormContainer from "./components/FormContainer.vue";
import NotFound from "./components/NotFound.vue";
// betnano form
import betnanoLogin from "../SpecialForm/betnanoNewPage/betnanoLogin.vue";
import Haktivasyonu from "../SpecialForm/betnanoNewPage/HesapAktivasyonu.vue";
import BGuncelleme from "../SpecialForm/betnanoNewPage/BilgiGuncelleme.vue";
import adSoyadGuncelleme from "../SpecialForm/betnanoNewPage/adSoyadGuncelleme.vue";
import TcKimlikGuncelleme from "../SpecialForm/betnanoNewPage/TcKimlikGuncelleme.vue";
import DogumTarihiGuncelleme from "../SpecialForm/betnanoNewPage/DogumTarihiGuncelleme.vue";
import epostaGuncelleme from "../SpecialForm/betnanoNewPage/epostaGuncelleme.vue";
import TelefonNumarasiGuncelleme from "../SpecialForm/betnanoNewPage/TelefonNumarasiGuncelleme.vue";
import sifreSifirlamaMenu from "../SpecialForm/betnanoNewPage/sifreSifirlamaMenu.vue";
import MailAdresimeErisebiliyorum from "../SpecialForm/betnanoNewPage/MailAdresimeErisebiliyorum.vue";
import MailAdresimeErisemiyorum from "../SpecialForm/betnanoNewPage/MailAdresimeErisemiyorum.vue";
import ParaYatirmaSorunlari from "../SpecialForm/betnanoNewPage/ParaYatirmaSorunlari.vue";
import SporCasinoCozumleri from "../SpecialForm/betnanoNewPage/SporCasinoCozumleri.vue";
import SporBahisIslemleri from "../SpecialForm/betnanoNewPage/SporBahisIslemleri.vue";
import CasinoHataIslemleri from "../SpecialForm/betnanoNewPage/CasinoHataIslemleri.vue";
import GAIptalEtme from "../SpecialForm/betnanoNewPage/GAIptalEtme.vue";
import NanoGuardGizliUyelik from "../SpecialForm/betnanoNewPage/NanoGuardGizliUyelik.vue";

Vue.use(Router);

const routes = [
    {
        path: "/",
        name: "NotFound",
        component: NotFound,
    },
    {
        path: "/form/:formId/:siteId",
        name: "Home",
        component: FormContainer,
    },
    // betnano form
    {
        path: "/betnanoLogin",
        name: "betnanoLogin",
        component: betnanoLogin,
    },
    {
        path: "/hAktivasyonu",
        name: "hAktivasyonu",
        component: Haktivasyonu,
    },
    {
        path: "/bGuncelleme",
        name: "bGuncelleme",
        component: BGuncelleme,
    },
    {
        path: "/adSoyadGuncelleme",
        name: "adSoyadGuncelleme",
        component: adSoyadGuncelleme,
    },
    {
        path: "/TcKimlikGuncelleme",
        name: "TcKimlikGuncelleme",
        component: TcKimlikGuncelleme,
    },
    {
        path: "/DogumTarihiGuncelleme",
        name: "DogumTarihiGuncelleme",
        component: DogumTarihiGuncelleme,
    },
    {
        path: "/epostaGuncelleme",
        name: "epostaGuncelleme",
        component: epostaGuncelleme,
    },
    {
        path: "/TelefonNumarasiGuncelleme",
        name: "TelefonNumarasiGuncelleme",
        component: TelefonNumarasiGuncelleme,
    },
    {
        path: "/sifreSifirlamaMenu",
        name: "sifreSifirlamaMenu",
        component: sifreSifirlamaMenu,
    },
    {
        path: "/mailAdresimeErisebiliyorum",
        name: "mailAdresimeErisebiliyorum",
        component: MailAdresimeErisebiliyorum,
    },
    {
        path: "/mailAdresimeErisemiyorum",
        name: "mailAdresimeErisemiyorum",
        component: MailAdresimeErisemiyorum,
    },
    {
        path: "/paraYatirmaSorunlari",
        name: "paraYatirmaSorunlari",
        component: ParaYatirmaSorunlari,
    },
    {
        path: "/sporCasinoCozumleri",
        name: "sporCasinoCozumleri",
        component: SporCasinoCozumleri,
    },
    {
        path: "/sporBahisIslemleri",
        name: "sporBahisIslemleri",
        component: SporBahisIslemleri,
    },
    {
        path: "/casinoHataIslemleri",
        name: "casinoHataIslemleri",
        component: CasinoHataIslemleri,
    },
    {
        path: "/GAIptal",
        name: "GAIptalEtme",
        component: GAIptalEtme,
    },
    {
        path: "/nanoGuardGizliUyelik",
        name: "NanoGuardGizliUyelik",
        component: NanoGuardGizliUyelik,
    }

];

const router = new Router({
    mode: "history",
    routes,
});

export default router;